const rankingData = [
  { rank: 1, title: '长相思 第二季', category: '古装玄幻', hot: '985万热度', trend: 'up' },
  { rank: 2, title: '你比星光美丽', category: '都市爱情', hot: '872万热度', trend: 'up' },
  { rank: 3, title: '玫瑰的故事', category: '都市情感', hot: '836万热度', trend: 'up' },
  { rank: 4, title: '庆余年 第二季', category: '古装权谋', hot: '791万热度', trend: 'down' },
  { rank: 5, title: '墨雨云间', category: '古装爱情', hot: '754万热度', trend: 'up' },
  { rank: 6, title: '狐妖小红娘月红篇', category: '古装仙侠', hot: '718万热度', trend: 'new' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热播剧集排行榜</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">实时追踪全网热度，为您精选当前最受瞩目的热播好剧</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingData.map((item) => (
            <div key={item.rank} className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group">
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-bold text-sm whitespace-nowrap ${
                item.rank === 1 ? 'bg-accent-500 text-white' :
                item.rank === 2 ? 'bg-primary-400 text-white' :
                item.rank === 3 ? 'bg-secondary-400 text-white' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank === 1 ? <i className="ri-vip-crown-line text-lg"></i> : item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-foreground-900 text-sm truncate group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-400">{item.category}</span>
                  <span className="text-xs text-primary-500">{item.hot}</span>
                </div>
              </div>
              <span className="text-xs">
                {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-base"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-base"></i>}
                {item.trend === 'new' && <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-600 whitespace-nowrap">新</span>}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}